import React from "react";
import { Box, Typography, Chip, Link } from "@mui/material";
import {
  formatWhatsappAttributionPanel,
  isGoogleStarterAttribution,
  providerLabel,
} from "../../utils/whatsappMessageContext";

export default function WhatsappAttributionPanel({ attribution }) {
  const panel = formatWhatsappAttributionPanel(attribution);
  if (!panel || (!panel.fromAd && !panel.rows?.length)) return null;
  const googleStarter = isGoogleStarterAttribution(attribution);

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "action.hover",
        mb: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexWrap: "wrap" }}>
        <Typography variant="subtitle2">Origem WhatsApp</Typography>
        {googleStarter ? (
          <Chip size="small" label="Google · mensagem" color="warning" variant="outlined" />
        ) : attribution?.provider ? (
          <Chip size="small" label={providerLabel(attribution.provider)} variant="outlined" />
        ) : null}
        {!googleStarter && attribution?.isStatusAd ? (
          <Chip size="small" label="Status" color="secondary" variant="outlined" />
        ) : null}
        {attribution?.uncertain ? (
          <Chip size="small" label="Origem inferida" color="warning" variant="outlined" />
        ) : null}
      </Box>

      {panel.imageUrl ? (
        <Box
          component="img"
          src={panel.imageUrl}
          alt="Criativo do anúncio"
          sx={{
            maxWidth: "100%",
            maxHeight: 120,
            borderRadius: 1,
            mb: 1,
            objectFit: "cover",
          }}
        />
      ) : null}

      {panel.rows.map((row) => (
        <Box key={row.label} sx={{ mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            {row.label}
          </Typography>
          {row.link ? (
            <Link href={row.value} target="_blank" rel="noopener noreferrer" variant="body2">
              {row.value}
            </Link>
          ) : (
            <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
              {row.value}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
